import ToolbarModule from './toolbar.module'

export default ToolbarModule
